// extracted by mini-css-extract-plugin
module.exports = {"footer":"GoodfyndSitesFooter_footer__xVxQG","footer-container":"GoodfyndSitesFooter_footer-container__y_fLY"};